module.exports = __webpack_public_path__ + "img/preferences.6c257488.jpg";